import React from 'react';
import {
  ArrowsClockwise as RefreshCw,
  Warning as AlertTriangle
} from '@phosphor-icons/react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Uncaught error:', error);
    console.error('[ErrorBoundary] Component stack:', errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-v4-bg flex items-center justify-center p-6">
          <div className="max-w-md w-full text-center">
            <div className="flex justify-center mb-6">
              <div className="h-16 w-16 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center">
                <AlertTriangle className="h-8 w-8 text-red-400" />
              </div>
            </div>

            <h1 className="text-xl font-semibold text-slate-100 mb-2">
              Algo salió mal
            </h1>
            <p className="text-slate-400 text-sm mb-6">
              Se produjo un error inesperado en la aplicación.
            </p>

            {this.state.error && (
              <div className="mb-6 p-3 rounded-lg bg-slate-800/60 border border-slate-700/50 text-left">
                <p className="text-xs font-mono text-red-400 break-all">
                  {this.state.error.message}
                </p>
              </div>
            )}

            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-v4-on-accent text-sm font-medium transition-colors"
            >
              <RefreshCw className="h-4 w-4" />
              Reintentar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
